import createModule from "../createModule"
import view from "./view"
import { Creators } from "model/hookUpdater"
import { Creators as notificationCreators } from "modules/notifications/model"
import { getRole } from "helpers/permissions/roles"
import { getResourceType, getResourceId, getResourceApplications, getAccountApplications, getPermissionLevel, getTabs } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    userId: props.params.userId,
    resourceAlias: props.params.resourceAlias,
    resourceType: getResourceType(state, props),
  }),
  required: ["account", "resourceAlias", "resourceType"],
  data: [{
    resource: "resourceApplications",
    passthrough: true,
    url: ({ resourceAlias, resourceType }) => {
      return {
        id: `resource-applications-${resourceAlias}`,
        query: `query($resourceAlias:IdOrShortIdOrAlias!, $resourceType:ResourceType!){
          resource(id:$resourceAlias, type:$resourceType){
            id
            name
            alias
            type
            permissionLevel
            applications {
              id
              description
              alias
              name
              permissionLevel
              createdAt
            }
          }
        }`,
        variables: {
          resourceAlias,
          resourceType,
        },
      }
    },
  },
  {
    resource: "accountApplications",
    passthrough: true,
    url: ({ account }) => {
      return {
        id: `account-applications-${account}`,
        query: `query{
            applications {
              id
              name
              createdAt
            }
        }`,
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    resourceId: getResourceId(state, props),
    resourceApplications: getResourceApplications(state, props),
    accountApplications: getAccountApplications(state, props),
    permissionLevel: getPermissionLevel(state, props),
    role: getRole(state),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
    addNotification: notificationCreators.add,
  },
}))
